// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__LXL7o","notes":"Notes_notes__3tC8_"};